const getIsoString = () =>
  new Date().toLocaleString('sv')

const getTimeFromDate = (date) => {
  if (date !== null) {
    return date.split(' ').pop();
  }
  return null;
};

const getDiffBetweenTwoDates = (firstDate, secondDate = null) => {
  firstDate = new Date(firstDate);
  secondDate ? secondDate = new Date(secondDate) : secondDate = new Date();

  const diff = secondDate.getTime() - firstDate.getTime();
  let msec = diff;
  let hh = Math.floor(msec / 1000 / 60 / 60);
  msec -= hh * 1000 * 60 * 60;
  let mm = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;
  let ss = Math.floor(msec / 1000);
  msec -= ss * 1000;

  hh = (hh < 10) ? `0${hh}` : hh;
  mm = (mm < 10) ? `0${mm}` : mm;
  ss = (ss < 10) ? `0${ss}` : ss;
  const results = hh + ":" + mm + ":" + ss;
  return results;
};

const getLocaleCurrentDay = () => {
  const today = new Date();
  const currentDate = today.toLocaleDateString('sv');
  return currentDate;
};

const getTodayRange = () => {
  const today = new Date;
  const startOfDay = today.setHours(6, 0, 0);
  const endOfDay = today.setHours(23, 0, 0);
  return [new Date(startOfDay), new Date(endOfDay)];
};

const getLastMonthRange = () => {
  const today = new Date;
  today.setHours(0, 0, 0);
  const firstDay = today.setDate(1);

  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const lastDay = new Date(year, month, 0);
  lastDay.setHours(23, 0, 0);
  return [new Date(firstDay), new Date(lastDay)];
};

const getPrevMonthRange = () => {
  const today = new Date;
  today.setHours(0, 0, 0);

  const isJanuary = !!(today.getMonth() === 0);
  const prevMonth = isJanuary ? 11 : today.getMonth() - 1;

  const firstDay = today.setMonth(prevMonth, 1);
  const lastDay = new Date();
  lastDay.setHours(23, 0, 0);
  lastDay.setDate(0);
  return [new Date(firstDay), new Date(lastDay)];
};

const getCurrentYearRange = () => {
  const firstDay = new Date;
  firstDay.setHours(0, 0, 0);
  firstDay.setMonth(0, 1);

  const lastDay = new Date;
  lastDay.setHours(23, 0, 0);
  lastDay.setMonth(11, 31);
  return [new Date(firstDay), new Date(lastDay)];
};

const getExistenceTimeRange = () => {
  const startDate = new Date();
  startDate.setFullYear(2020);
  const endDate = new Date();
  return [new Date(startDate), endDate];
};

const getCurrentWeekRange = () => {
  const monday = new Date();
  const day = (monday.getDay() == 0 ? -6 : 1);
  monday.setDate(monday.getDate() - monday.getDay() + day);
  monday.setHours(0, 0, 0);

  const sunday = new Date();
  sunday.setDate(sunday.getDate() - sunday.getDay() + 7);
  sunday.setHours(23, 0, 0);
  return [new Date(monday), new Date(sunday)];
};

export const date = {
  getIsoString,
  getTimeFromDate,
  getLocaleCurrentDay,
  getDiffBetweenTwoDates,
  getTodayRange,
  getLastMonthRange,
  getPrevMonthRange,
  getCurrentYearRange,
  getExistenceTimeRange,
  getCurrentWeekRange,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/date.js